export const numbersOnly = input => {
  if (!input) return '';
  return input.replace(/\D+/g, '');
};
export const getClosestValue = function (target) {
  let haystack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return haystack.sort((stalk1, stalk2) => Math.abs(target - stalk1) - Math.abs(target - stalk2))[0];
};